/**
 * Created by olga on 27.09.2025
 */

const MergeCustomGeneratorTutorial = function () {
    return new TutorialScenario(MergeCustomGeneratorTutorial.NAME, {
        listSteps: MergeCustomGeneratorTutorial.listSteps,

        isAvailable: function () {
            return Merge2.current && Merge2.current.mode === Merge2.MODE_GAME
                && !cleverapps.forces.isShown(Forces.MERGE2_GENERATOR_O)
                && Merge2.current.field.countEmptySlots() > 0
                && !Merge2.current.customers.getSideQuestCustomer()
                && Merge2.current.field.listAvailableUnits((unit) => unit.code === MergeCustomGeneratorTutorial.UNIT.code
                        && unit.stage === MergeCustomGeneratorTutorial.UNIT.stage
                        && !unit.findComponent(Grounded)
                        && unit.findComponent(Merge2Generator).canMine()
                        && cleverapps.lives.amount >= unit.findComponent(Merge2Generator).data.energy).length > 0;
        }
    });
};

MergeCustomGeneratorTutorial.listSteps = function () {
    const steps = [];

    MergeCustomGeneratorTutorial.STEPS.forEach((step) => {
        if (step.dialogue) {
            steps.push(Merge2TutorialHelper.createDialogueStep(step));
        }

        if (step.clickUnit) {
            steps.push(Merge2TutorialHelper.createClickUnitStep(step));
        }

        if (step.recipe) {
            steps.push(Merge2TutorialHelper.createReplaceOrderStep(step));
        }
        if (step.unitsLibrary) {
            steps.push(Merge2TutorialHelper.createUnitsLibraryStep(step));
        }
    });
    return steps;
};

MergeCustomGeneratorTutorial.UNIT = {
    code: "O",
    stage: 3
};
MergeCustomGeneratorTutorial.INGREDIENT_UNIT = {
    code: "o",
    stage: 9
};
MergeCustomGeneratorTutorial.NAME = "merge2_custom_generator";

MergeCustomGeneratorTutorial.STEPS = [
    {
        dialogue: true,
        dialogueConfig: bundles.side_quest_tutorial_O.jsons.dialogues_json,
        imageBundle: "side_quest_tutorial_O"
    },
    {
        customerIndex: Merge2Customers.SIDE_QUEST_CUSTOMER_INDEX,
        recipe: {
            ingredients: [{ unit: MergeCustomGeneratorTutorial.INGREDIENT_UNIT, amount: 1 }]
        }
    },

    {
        clickUnit: true,
        force: Forces.MERGE2_GENERATOR_O,
        unit: MergeCustomGeneratorTutorial.UNIT
    },

    {
        clickUnit: true,
        unit: {
            code: "o",
            stage: 0
        },
        finishEvent: "unitSelectionChanged",
        text: "SideQuestTutorialO.text2"
    },

    {
        unitsLibrary: true,
        text: "SideQuestTutorialO.text3"
    }
];